import { Budget } from '@/types/financial';
import { logger } from '@/utils/logger';

export interface BudgetsState {
  budgets: Budget[];
  isLoading: boolean;
  error: string | null;
}

export type BudgetsAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_BUDGETS'; payload: Budget[] }
  | { type: 'ADD_BUDGET'; payload: Budget }
  | { type: 'UPDATE_BUDGET'; payload: { id: string; updates: Partial<Budget> } }
  | { type: 'DELETE_BUDGET'; payload: string }
  | { type: 'CLEAR_BUDGETS' };

export const initialState: BudgetsState = {
  budgets: [],
  isLoading: false,
  error: null,
};

export function budgetsReducer(
  state: BudgetsState,
  action: BudgetsAction
): BudgetsState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_ERROR':
      return { ...state, error: action.payload };

    case 'SET_BUDGETS':
      return { 
        ...state, 
        budgets: action.payload,
        isLoading: false,
        error: null
      };

    case 'ADD_BUDGET':
      logger.debug('Adding budget to state', { id: action.payload.id });
      return {
        ...state,
        budgets: [...state.budgets, action.payload],
        error: null,
      };

    case 'UPDATE_BUDGET': {
      const updated = state.budgets.map(b =>
        b.id === action.payload.id ? { ...b, ...action.payload.updates } : b
      );
      logger.debug('Updated budget in state', { id: action.payload.id });
      return { ...state, budgets: updated, error: null };
    }

    case 'DELETE_BUDGET': {
      const filtered = state.budgets.filter(b => b.id !== action.payload);
      logger.debug('Deleted budget from state', { id: action.payload });
      return { ...state, budgets: filtered, error: null };
    }

    case 'CLEAR_BUDGETS':
      return { ...state, budgets: [], error: null };

    default:
      return state;
  }
}
